"use strict";

var formatAbiRawDecodedData = require("./format-abi-raw-decoded-data");

function formatAbiRawDecodedDataArray(dataInputTypes, decodedDataArray) {
  return decodedDataArray.map(function (decodedData, i) {
    return formatAbiRawDecodedData(dataInputTypes[i], decodedData);
  });
}

module.exports = formatAbiRawDecodedDataArray;



//////////////////
// WEBPACK FOOTER
// ./node_modules/speedomatic/src/format-abi-raw-decoded-data-array.js
// module id = 507
// module chunks = 146